export const GAP = 32
export const TABLET = 769
export const DESKTOP = 960 + 2*GAP
export const WIDESCREEN = 1152 + 2*GAP
export const FULLHD = 1344 + 2*GAP
